import { render, staticRenderFns } from "./CustomerNoteContent.vue?vue&type=template&id=3e1e9f1c&scoped=true&"
import script from "./CustomerNoteContent.vue?vue&type=script&lang=js&"
export * from "./CustomerNoteContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNoteContent.vue?vue&type=style&index=0&id=3e1e9f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e9f1c",
  null
  
)

export default component.exports